/**
 * Read-only SVG preview of a drill diagram.
 * Mirrors rendering logic from DrillBoardDialog.
 */
function renderShape(s, key) {
  if (s.type === "line" || s.type === "arrow") {
    const [a, b] = s.points;
    return (
      <line
        key={key}
        x1={a.x} y1={a.y} x2={b.x} y2={b.y}
        stroke={s.color} strokeWidth="0.4" strokeLinecap="round"
        markerEnd={s.type === "arrow" ? `url(#preview-arrow-${s.color.replace("#", "")})` : undefined}
      />
    );
  }
  if (s.type === "free") {
    const d = s.points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
    return (
      <path
        key={key}
        d={d}
        fill="none"
        stroke={s.color}
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  }
  return null;
}

function renderPiece(p) {
  const { id, type, x, y, color, label } = p;
  if (type === "player") {
    return (
      <g key={id} transform={`translate(${x}, ${y})`}>
        <circle r="2.8" fill={color} stroke="white" strokeWidth="0.4" />
        {label && (
          <text textAnchor="middle" dominantBaseline="central" fontSize="2" fontWeight="700" fill="white">
            {label}
          </text>
        )}
      </g>
    );
  }
  if (type === "cone") {
    return (
      <g key={id} transform={`translate(${x}, ${y})`}>
        <polygon points="0,-2.5 2,1.5 -2,1.5" fill={color} stroke="black" strokeWidth="0.2" />
      </g>
    );
  }
  if (type === "hurdle") {
    return (
      <g key={id} transform={`translate(${x}, ${y})`}>
        <rect x="-3" y="-0.6" width="6" height="1.2" fill={color} stroke="white" strokeWidth="0.2" />
      </g>
    );
  }
  if (type === "ball") {
    return (
      <g key={id} transform={`translate(${x}, ${y})`}>
        <circle r="1.5" fill={color} stroke="black" strokeWidth="0.3" />
        <path d="M -1.5 0 L 1.5 0 M 0 -1.5 L 0 1.5" stroke="black" strokeWidth="0.2" />
      </g>
    );
  }
  return null;
}

export default function DrillDiagramPreview({ diagram, className = "" }) {
  if (!diagram || (!diagram.pieces?.length && !diagram.drawings?.length)) {
    return (
      <div
        className={`rounded-lg pitch-bg flex items-center justify-center text-white/60 text-xs aspect-[5/3] ${className}`}
      >
        Nessun diagramma
      </div>
    );
  }
  const arrowColors = [...new Set((diagram.drawings || []).map((d) => d.color))];
  return (
    <div className={`rounded-lg overflow-hidden pitch-bg aspect-[5/3] ${className}`}>
      <svg viewBox="0 0 100 60" preserveAspectRatio="none" className="w-full h-full">
        <defs>
          {arrowColors.map((c) => (
            <marker
              key={c}
              id={`preview-arrow-${c.replace("#", "")}`}
              viewBox="0 0 10 10"
              refX="6" refY="5"
              markerWidth="4" markerHeight="4"
              orient="auto-start-reverse"
            >
              <path d="M 0 0 L 10 5 L 0 10 z" fill={c} />
            </marker>
          ))}
        </defs>
        <g stroke="rgba(255,255,255,0.6)" strokeWidth="0.3" fill="none">
          <rect x="1" y="1" width="98" height="58" />
          <line x1="50" y1="1" x2="50" y2="59" />
        </g>
        {(diagram.drawings || []).map((d, i) => renderShape(d, i))}
        {(diagram.pieces || []).map((p) => renderPiece(p))}
      </svg>
    </div>
  );
}
